import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import React from 'react'
import { PatientFormGridItem } from './FormField'
import CommunicationReceiver from './CommunicationReceiver'
import { usePatientFormI18n } from '../utils/patientFormI18n'

export const PatientCommunicationToPref = ({
  communicationToPref = {},
  onPreferenceChange,
  onAddReceiver,
  onUpdateReceiver,
  onRemoveReceiver,
  editMode = true,
  validationHook,
}) => {
  const { copy } = usePatientFormI18n()
  const {
    toPatient = true,
    toAttendant = true,
    toOthers = true,
    receivers = [],
  } = communicationToPref || {}

  return (
    <>
      {/* Boolean Preferences Section */}
      <PatientFormGridItem gridConfig={{ xs: 12 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={toPatient}
                  onChange={(e) => {
                    if (editMode && onPreferenceChange) {
                      onPreferenceChange('toPatient', e.target.checked)
                    }
                  }}
                  disabled={!editMode}
                  size="small"
                />
              }
              label={copy.sendToPatientLabel}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={toAttendant}
                  onChange={(e) => {
                    if (editMode && onPreferenceChange) {
                      onPreferenceChange('toAttendant', e.target.checked)
                    }
                  }}
                  disabled={!editMode}
                  size="small"
                />
              }
              label={copy.sendToAttendantLabel}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={toOthers}
                  onChange={(e) => {
                    if (editMode && onPreferenceChange) {
                      onPreferenceChange('toOthers', e.target.checked)
                    }
                  }}
                  disabled={!editMode}
                  size="small"
                />
              }
              label={copy.sendToOthersLabel}
            />
          </Grid>
        </Grid>
      </PatientFormGridItem>

      {/* Additional Recipients Section */}
      {toOthers && (
        <PatientFormGridItem gridConfig={{ xs: 12 }}>
          <div className="d-flex flex-column">
            <div className="d-flex align-items-center gap-2 mb-3">
              <h6 className="mb-0">{copy.additionalRecipientsTitle}</h6>
              {editMode && onAddReceiver && (
                <AddCircleOutlineIcon
                  style={{ cursor: 'pointer', fontSize: '20px' }}
                  onClick={onAddReceiver}
                />
              )}
            </div>

            {receivers.length === 0 && (
              <p className="text-muted mb-2" style={{ fontSize: '14px' }}>
                {copy.additionalRecipientsEmpty}{' '}
                {editMode && copy.additionalRecipientsHint}
              </p>
            )}

            {receivers.map((receiver, index) => (
              <CommunicationReceiver
                key={index}
                receiver={receiver}
                index={index}
                onUpdate={onUpdateReceiver}
                onRemove={onRemoveReceiver}
                editMode={editMode}
                validationHook={validationHook}
              />
            ))}
          </div>
        </PatientFormGridItem>
      )}
    </>
  )
}

export default PatientCommunicationToPref
